import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import LicenseService from "../../../services/LicensesService";
import { FormLicenseType } from "./FormLicenseType";
import { useEffect, useState } from "react";

export function EditLicenseType({ ...props }) {
   const { licenseTypeId } = useParams();
   const { state } = useLocation();
   const [licenseType, setLicenseType] = useState(state);
   const [type, setType] = useState("");

   async function loadLicenseType(id) {
      const response = await LicenseService.getLicenseType(id);
      if (response.data) {
         setLicenseType(response.data);
      }
   }

   useEffect(() => {
      setType(licenseTypeId || state ? "edicao" : "cadastro");

      if (licenseType) {
         setLicenseType(state);
         return;
      }

      if (licenseTypeId) {
         loadLicenseType(licenseTypeId);
      }
   }, [state, licenseTypeId]);

   return (
      <CadastroContainer>
         <FormLicenseType licenseType={licenseType} type={type} />
      </CadastroContainer>
   );
}